import React from "react";

export function Badge({ children, variant = "default", ...props }) {
  const base = "px-2 py-1 rounded text-xs font-medium";
  const variants = {
    default: "bg-gray-100 text-gray-800",
    secondary: "bg-blue-100 text-blue-800",
    outline: "border border-gray-300 text-gray-700",
  };
  return (
    <span {...props} className={`${base} ${variants[variant] || variants.default}`}>
      {children}
    </span>
  );
}
